import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { SearchFilterAction } from './searchFilter.action';
import { searchFilterInitialState } from './searchFilter.constans';
import { ISearchFilterStore } from './SearchFilter.interface';

export const searchFilterReducer = reducerWithInitialState(searchFilterInitialState)
  .case(SearchFilterAction.setSearch, (state, payload): ISearchFilterStore => {
    return {
      ...state,
      search: payload,
    };
  })
  .case(SearchFilterAction.destroy, (): ISearchFilterStore => {
    return {
      ...searchFilterInitialState,
    };
  });
